module.exports = __webpack_public_path__ + "img/mb-fail-icon.5f6ab7db.png";